export const SingleBook = {
  ContinueBtn: 'continue-btn',
} as const;